import { render, staticRenderFns } from "./mainHomeTemp.vue?vue&type=template&id=53e8f0a4&scoped=true&"
import script from "./mainHomeTemp.vue?vue&type=script&lang=js&"
export * from "./mainHomeTemp.vue?vue&type=script&lang=js&"
import style0 from "./mainHomeTemp.vue?vue&type=style&index=0&id=53e8f0a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e8f0a4",
  null
  
)

export default component.exports